import React, { useState } from 'react';
import { Box, IconButton, useMediaQuery, useTheme } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SidebarNavigation from './SidebarNavigation';
import ViewContainer from './ViewContainer';
import TopBar from './TopBar';

/**
 * MainLayout component provides the overall application layout
 * with top bar, sidebar navigation, and main content area.
 * On mobile (below md breakpoint), the sidebar collapses to a
 * hamburger-triggered temporary drawer.
 */
function MainLayout() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  return (
    <Box sx={{ display: 'flex', height: '100vh', width: '100vw', overflow: 'hidden' }}>
      {/* Sidebar Navigation */}
      <SidebarNavigation
        isMobile={isMobile}
        mobileOpen={mobileDrawerOpen}
        onMobileClose={() => setMobileDrawerOpen(false)}
      />
      
      {/* Main Content Area */}
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        flex: 1, 
        overflow: 'hidden',
        minHeight: 0,
        width: '100%'
      }}>
        {/* Mobile hamburger + Top Bar — does not grow/shrink */}
        <Box sx={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
          {isMobile && (
            <Box sx={{ 
              px: 1, 
              py: 0.5, 
              borderBottom: '1px solid',
              borderColor: 'divider',
              bgcolor: 'background.paper',
              display: 'flex',
              alignItems: 'center'
            }}>
              <IconButton
                aria-label="open navigation"
                onClick={() => setMobileDrawerOpen(true)}
                edge="start"
                sx={{ mr: 1 }}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          )}
          <TopBar />
        </Box>

        {/* View Container for displaying the selected view */}
        <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
          <ViewContainer />
        </Box>
      </Box>
    </Box>
  );
}

export default MainLayout; 